export default __webpack_public_path__ + "static/media/NotoSansKR-Thin.9d23ca66.woff2";